export default __webpack_public_path__ + "static/media/Roboto-Light.72738703.svg";